import MainLayout from '@/pages/Layout/MainLayout.vue'
const knowledgebase = () => import('@/pages/knowledgebase/KnowledgeBase.vue')

export default {
  path: '/knowledgebase',
  //redirect: '/files/store',
  component: MainLayout,
  children: [
    {
      path: '',
      component: knowledgebase,
      meta: {
        title: 'База знаний',  
      }
    },
  ]
}
